import React from 'react';

export const Deform: React.FC = () => (
  <svg height="512" viewBox="0 0 64 64" width="512" xmlns="http://www.w3.org/2000/svg">
    <title>Deform filter</title>
    <circle cx="14" cy="10" fill="#c7e2fc" r="8" />
    <circle cx="32" cy="32" fill="#c7e2fc" r="17" />
    <path
      d="M48 26c5.523 0 10-4.477 10-10S53.523 6 48 6s-10 4.477-10 10v.089A17.052 17.052 0 0 1 47.911 26zM46 31.999h-2c0-6.617-5.383-12-12-12v-2c7.719.001 14 6.281 14 14z"
      fill="#ebf7fe"
    />
    <circle cx="54" cy="54" fill="#ebf7fe" r="8" />
    <path
      d="M58.999 53.999h-2c0-1.654-1.346-3-3-3v-2c2.757.001 5 2.243 5 5z"
      fill="#c7e2fc"
    />
    <path
      d="M19 9.999h-2c0-1.654-1.346-3-3-3V5c2.757 0 5 2.242 5 4.999z"
      fill="#ebf7fe"
    />
    <path
      d="M54.999 15.999h-2c0-2.757-2.243-5-5-5V9c3.86 0 7 3.14 7 6.999z"
      fill="#c7e2fc"
    />
    <circle cx="15" cy="58" fill="#c7e2fc" r="4" />
    <circle cx="6" cy="40" fill="#c7e2fc" r="4" />
    <g fill="#ebf7fe">
      <circle cx="9" cy="28" r="4" />
      <circle cx="56" cy="35" r="3" />
      <circle cx="35" cy="55" r="3" />
      <circle cx="32" cy="8" r="2" />
      <circle cx="14" cy="49" r="2" />
    </g>
    <path d="M49.258 26.921c5.474-.627 9.741-5.283 9.741-10.922 0-6.065-4.935-11-11-11-5.639 0-10.295 4.267-10.922 9.741A17.961 17.961 0 0 0 32 14c-9.925 0-18 8.075-18 18s8.075 18 18 18 18-8.075 18-18a17.976 17.976 0 0 0-.742-5.079zM48 7c4.962 0 9 4.037 9 9 0 4.771-3.734 8.675-8.431 8.971a18.103 18.103 0 0 0-9.54-9.54C39.324 10.733 43.229 7 48 7zM32 47.999c-8.823 0-16-7.177-16-16s7.177-16 16-16c8.822 0 16 7.177 16 16-.001 8.823-7.178 16-16 16z" />
    <path d="M32 18v2c6.617 0 12 5.383 12 12h2c-.001-7.72-6.281-14-14-14zM54 45c-4.963 0-9 4.037-9 9 0 4.962 4.037 9 9 9 4.962 0 9-4.037 9-9-.001-4.963-4.038-9-9-9zm0 15.999c-3.86 0-7-3.14-7-7s3.14-7 7-7c3.859 0 7 3.14 7 7-.001 3.86-3.141 7-7 7z" />
    <path d="M54 49v2c1.654 0 3 1.346 3 3h2a5.006 5.006 0 0 0-5-5zM16.999 9.999h2c0-2.757-2.243-5-5-5v2c1.654.001 3 1.346 3 3z" />
    <path d="M14 18.999c4.962 0 9-4.037 9-9s-4.037-9-9-9-9 4.037-9 9 4.037 9 9 9zM14 3c3.859 0 7 3.14 7 7 0 3.859-3.14 7-7 7s-7-3.14-7-7 3.14-7 7-7zM52.999 15.999h2c0-3.859-3.14-7-7-7v2c2.757.001 5 2.243 5 5zM15 53c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5a5.006 5.006 0 0 0-5-5zm0 7.999c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3a3.005 3.005 0 0 1-3 3zM6 35c-2.757 0-5 2.243-5 5s2.243 5 5 5 5-2.243 5-5a5.006 5.006 0 0 0-5-5zm0 7.999c-1.654 0-3-1.346-3-3s1.345-3 3-3c1.654 0 3 1.346 3 3a3.005 3.005 0 0 1-3 3zM9 32.999c2.757 0 5-2.243 5-5s-2.243-5-5-5-5 2.243-5 5 2.242 5 5 5zM9 25c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3c0-1.655 1.345-3 3-3zM56 31c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4a4.005 4.005 0 0 0-4-4zm0 5.999c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2a2.003 2.003 0 0 1-2 2zM35 51c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4a4.005 4.005 0 0 0-4-4zm0 5.999c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2a2.003 2.003 0 0 1-2 2zM32 10.999c1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3 1.345 3 3 3zM32 7a1.001 1.001 0 0 1 0 2 1 1 0 0 1 0-2zM11 49c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3c-1.655 0-3 1.345-3 3zm3-1a1.001 1.001 0 0 1 0 2 1 1 0 0 1 0-2z" />
  </svg>
);
